<template>
  <v-snackbar
    v-model="toastState.isVisible"
    :color="snackColor"
    :timeout="toastState.duration"
    location="top"
    rounded="lg"
    elevation="4"
  >
    <div class="d-flex align-center gap-2">
      <i v-if="icon" :class="icon" style="font-size:16px"></i>
      <span style="font-family:var(--an-font);font-weight:600;font-size:13px">{{ toastState.message }}</span>
    </div>
  </v-snackbar>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useToast } from '@/composables/useToast';

const { toastState } = useToast();

const icon = computed(() => {
  switch (toastState.type) {
    case 'success': return 'fas fa-check-circle';
    case 'error':   return 'fas fa-exclamation-circle';
    case 'warning': return 'fas fa-exclamation-triangle';
    default:        return 'fas fa-info-circle';
  }
});

const snackColor = computed(() => {
  switch (toastState.type) {
    case 'success': return '#2E7D5A';
    case 'error':   return '#E53935';
    case 'warning': return '#F5A623';
    default:        return '#374151';
  }
});
</script>
